import { useEffect, useRef } from 'react';

// Pilha das cascas abertas: só a de cima reage ao Esc. É UMA pilha para modal e
// gaveta juntos: a confirmação aberta de dentro de uma gaveta, ou a gaveta do
// detalhe aberta por cima da de duplicatas, tem de fechar primeiro.
//
// TODA casca aberta entra na pilha, inclusive as que não reagem ao Esc (operação
// em curso). Essas ENGOLEM o Esc: sem isso, um Esc no progresso de um lote, aberto
// por cima de outra casca, fecharia a de trás.
const pilhaDoEsc: symbol[] = [];

// O Esc que não é da casca (09/10/2026):
//  - já tratado por quem está dentro dela (popover, dropdown aberto: eles marcam `preventDefault`);
//  - vindo de um <select> ou de um campo de data/hora: não há como saber se o seletor nativo está ABERTO, e o Esc
//    que fecha o calendário não pode fechar o modal junto. Custa um Esc "morto" com o foco nesses campos.
const CAMPO_COM_SELETOR = /^(date|datetime-local|month|time|week)$/;
function escDeOutroDono(e: KeyboardEvent): boolean {
  if (e.defaultPrevented) return true;
  const alvo = e.target as HTMLElement | null;
  if (!alvo || !alvo.tagName) return false;
  if (alvo.tagName === 'SELECT') return true;
  return alvo.tagName === 'INPUT' && CAMPO_COM_SELETOR.test((alvo as HTMLInputElement).type);
}

/**
 * O Esc da casca de cima da pilha chama `aoEsc`; `null` engole o Esc (a casca não sai por ele).
 *
 * ⚠️ Escuta em `window`, e não em `document`, DE PROPÓSITO: os popovers de dentro da casca escutam em `document`, que
 * na fase de bolha vem ANTES de `window`. Assim, quando a casca recebe o evento, o popover já marcou que o Esc era dele.
 */
export function useFecharNoEsc(aoEsc: (() => void) | null) {
  const aoEscRef = useRef(aoEsc);
  aoEscRef.current = aoEsc;
  useEffect(() => {
    const eu = Symbol('casca');
    pilhaDoEsc.push(eu);
    const aoTeclar = (e: KeyboardEvent) => {
      if (e.key !== 'Escape' || pilhaDoEsc[pilhaDoEsc.length - 1] !== eu) return;
      if (escDeOutroDono(e)) return;
      const acao = aoEscRef.current;
      if (!acao) return;
      e.preventDefault();
      acao();
    };
    window.addEventListener('keydown', aoTeclar);
    return () => {
      window.removeEventListener('keydown', aoTeclar);
      const i = pilhaDoEsc.indexOf(eu);
      if (i >= 0) pilhaDoEsc.splice(i, 1);
    };
  }, []);
}
